interface FoodPairingChipsProps {
  pairings: string[];
  onSelect?: (food: string) => void;
}

export default function FoodPairingChips({ pairings, onSelect }: FoodPairingChipsProps) {
  if (pairings.length === 0) return null;

  return (
    <div className="food-pairing-chips">
      {pairings.map((food) => (
        <button
          key={food}
          className="food-chip"
          onClick={() => onSelect?.(food)}
        >
          {food}
        </button>
      ))}
    </div>
  );
}
